var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnClose = function SvgIAvnClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "icon-with-background"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 11,
    cx: 11,
    cy: 11,
    fill: "#9B9AC8",
    "data-no-stroke": "true"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "inner",
    stroke: "#E6E5FF",
    strokeWidth: 1.297,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.434 7.199 7.133 7.133M14.567 7.198l-7.133 7.133",
    "data-no-fill": "true"
  }))));
};
export { SvgIAvnClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjIgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS12YXJpYW50PSJpY29uLXdpdGgtYmFja2dyb3VuZCI+CiAgICA8ZyBjbGFzcz0iYmFja2dyb3VuZCI+CiAgICAgICAgPGNpcmNsZSByPSIxMSIgY3g9IjExIiBjeT0iMTEiIGZpbGw9IiM5QjlBQzgiIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIi8+CiAgICA8L2c+CiAgICA8ZyBjbGFzcz0iaW5uZXIiPgogICAgICAgIDxwYXRoIGQ9Ik03LjQzNDE5IDcuMTk4OTRMMTQuNTY3MiAxNC4zMzE5IiBzdHJva2U9IiNFNkU1RkYiIHN0cm9rZS13aWR0aD0iMS4yOTY4NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNC41NjcyIDcuMTk4NDZMNy40MzQyMSAxNC4zMzE0IiBzdHJva2U9IiNFNkU1RkYiIHN0cm9rZS13aWR0aD0iMS4yOTY4NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPC9nPgo8L3N2Zz4=";